// Core packages
import { ElementRef, Renderer2, RendererFactory2 } from "@angular/core";
import { Title } from "@angular/platform-browser";
// Third party packages
// Custom packages
import { ConfigService } from "src/app/shared/services/config.service";
import * as i0 from "@angular/core";
import * as i1 from "@angular/platform-browser";
import * as i2 from "./config.service";
var ThemeService = /** @class */ (function () {
    /**
     * Class constctor
     */
    function ThemeService(rendererFactory, titleService, configService) {
        this.titleService = titleService;
        this.configService = configService;
        this.renderer = rendererFactory.createRenderer(null, null);
    }
    /**
     * Set given title as page title
     *
     * @since 1.0.0
     */
    ThemeService.prototype.setPageTitle = function (title, withPostFix) {
        if (withPostFix === void 0) { withPostFix = true; }
        if (!withPostFix) {
            this.titleService.setTitle(title);
        }
        else {
            this.titleService.setTitle(title + " | " + this.configService.ownerNicename);
        }
    };
    /**
     * Set given class as body class
     *
     * @since 1.0.0
     *
     * @param className the class to add
     * @returns undefined
     */
    ThemeService.prototype.setClassToBody = function (className) {
        this.renderer.addClass(document.body, className);
    };
    /**
     * Remove given class from body tag
     *
     * @since 1.0.0
     *
     * @param className the class to remove
     */
    ThemeService.prototype.removeClassToBody = function (className) {
        this.renderer.removeClass(document.body, className);
    };
    /**
     * Set given class to given element
     *
     * @since 1.0.0
     *
     * @param element The target element
     * @param className The class to add
     */
    ThemeService.prototype.setClassToElement = function (element, className) {
        this.renderer.addClass(element, className);
    };
    /**
     * Remove given class to given element
     *
     * @since 1.0.0
     *
     * @param element The target element
     * @param className The class to remove
     */
    ThemeService.prototype.removeClassToElement = function (element, className) {
        this.renderer.removeClass(element, className);
    };
    ThemeService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ThemeService_Factory() { return new ThemeService(i0.ɵɵinject(i0.RendererFactory2), i0.ɵɵinject(i1.Title), i0.ɵɵinject(i2.ConfigService)); }, token: ThemeService, providedIn: "root" });
    return ThemeService;
}());
export { ThemeService };
